import Vue from 'vue';
import './src/plugins/vuetify';
// import router from './router'

import BootstrapVue from 'bootstrap-vue';

import Default from './src/Layout/Wrappers/baseLayout.vue';
import Pages from './src/Layout/Wrappers/pagesLayout.vue';
import Apps from './src/Layout/Wrappers/appLayout.vue';

import './bpc-style.scss';
import './bpc-style-big-captain.scss';
import './bpc-style-public.scss';
import 'tippy.js/dist/tippy.css';
import 'noty/src/noty.scss';
import 'noty/src/themes/mint.scss';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);

Vue.component('default-layout', Default);
Vue.component('userpages-layout', Pages);
Vue.component('apps-layout', Apps);
